const ALPHABET = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'
const LENGTH = 12

export function nanoid() {
  let id = ''
  for (let i = 0; i < LENGTH; i += 1) {
    const index = Math.floor(Math.random() * ALPHABET.length)
    id += ALPHABET[index]
  }
  return id
}
